import { extendsModule, baseFormItem } from 'src/store/base';
import * as types from 'src/store/types';

export default extendsModule(baseFormItem, {
  state: {
    _moduleKey: 'procedural-creative-identity',
    identity_type: 0, // identity账号类型
    identity_id: '', // identity账号Id
    identity_data: {}, // identity账号信息
  },
  getters: {
    formItemData(state) {
      return {
        identity_type: state.identity_type || 0,
        identity_id: state.identity_id || '',
        identity_data: state.identity_data || {},
      };
    },
    pcdIdentityData(state) {
      return state.identity_data || {};
    },
  },
  mutations: {
    [types.UPDATE_PCD_IDENTITY_TYPE](state, type = 0) {
      state.identity_type = type;
    },
    [types.UPDATE_PCD_IDENTITY_ID](state, id = '') {
      state.identity_id = id;
    },
    [types.UPDATE_PCD_IDENTITY_DATA](state, data = {}) {
      state.identity_data = data;
    },
  },
  actions: {
    data2State({ commit }, formData) {
      const data = {
        identity_type: formData.identity_type || 0,
        identity_id: formData.identity_id || '',
        identity_data: formData.identity_data || {},
      };
      const {
        identity_id, identity_type, avatar_icon, source, app_name,
      } = formData;
      // 处理复制或编辑时对identity_data的回填
      if (identity_id && identity_type && !Object.keys(data.identity_data).length) {
        data.identity_data = {
          identity_id,
          identity_type,
          avatar_icon,
          display_name: source || app_name,
        };
      }
      commit('update', data);
    },
    identityData2State({ commit }, initData = {}) {
      const data = {
        identity_id: initData.identity_id,
        identity_type: initData.identity_type,
        avatar_icon: initData.avatar_icon,
        display_name: initData.display_name,
      };
      commit(types.UPDATE_PCD_IDENTITY_DATA, data);
    },
  },
});
